import React from "react";
import { Button } from "../../../components/ui/button";
import useInViewOnce from "../useInViewOnce";

const MidPageCTA = () => {
  const [setRef, isInView] = useInViewOnce();

  const handleScrollToForm = () => {
    const el = document.getElementById("form-pemesanan");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section
      ref={setRef}
      className={`mb-12 rounded-3xl border border-border
    bg-gradient-to-r from-secondary via-background to-accent
    px-4 py-6 text-center shadow-sm md:mb-16 md:px-8 md:py-8
    ${isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
    transition-all duration-300 ease-out`}
    >
      <h2 className="text-base font-semibold tracking-tight text-foreground md:text-lg">
        Masak Hari Ini, Buktikan Rasanya
      </h2>

      <p className="mt-2 text-xs text-muted-foreground md:text-sm">
        Jangan cuma bayangin rasa kuah beulangong dan kari Aceh. Coba sekali,
        dan lihat sendiri bedanya di dapur kamu.
      </p>

      <Button
        onClick={handleScrollToForm}
        className="mt-4 rounded-full bg-primary px-6 text-sm font-semibold
      text-primary-foreground shadow-md transition-transform duration-200 ease-out
      hover:-translate-y-0.5 hover:bg-primary/90 hover:shadow-lg
      active:translate-y-0"
      >
        Saya Mau Pesan Sekarang
      </Button>
    </section>
  );
};

export default MidPageCTA;
